import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PaginatorMixin from '@/helpers/mixins/PaginatorMixin';
import CopilotAllMessages from '@/plugins/graphql/queries/v2/copilot_inbox_manager/copilot-all-messages.gql';
import InboxConversation from '@/components/v3/inbox_manager/InboxConversation.vue';
import moment from 'moment';
let FacebookComments = class FacebookComments extends Mixins(PaginatorMixin) {
    constructor() {
        super(...arguments);
        this.fbPostsAndMessages = [];
        this.shouldScrollToBottom = true;
        this.expandedPosts = {};
        this.isFetchMore = false;
        this.defaultPhoto = require('@/assets/images/cg_logo.png');
        this.isReplying = false;
    }
    unreplyMessage() {
        this.isReplying = false;
    }
    checkIfLastMessage(message) {
        const filteredPosts = this.fbPostsAndMessages.filter((item) => item.platformOrigin === 'messenger' && item.sender === 'customer');
        const lastFilteredPost = filteredPosts.pop();
        if (lastFilteredPost.baseGlobalId === message.baseGlobalId) {
            return true;
        }
        return false;
    }
    clickReply(message) {
        this.isReplying = !this.isReplying;
        this.expandedPosts = {};
        if (this.isReplying === false) {
            return this.$store.commit('setSelectedFbpost', {});
        }
    }
    // private mapNewFbPost(newInboxFbPost) {
    //   let isExisting = false;
    //   const updatedInboxFbPosts = this.fbPosts.filter((inboxFbPost) => {
    //     if (inboxFbPost.baseGlobalId === newInboxFbPost.baseGlobalId) {
    //       isExisting = true;
    //       return false;
    //     }
    //     return true;
    //   });
    //   if (!isExisting) {
    //     this.fbPosts = [...this.fbPosts, newInboxFbPost];
    //   }
    // }
    onSelectedRecipient() {
        this.expandedPosts = {};
        this.$store.commit('setSelectedFbpost', {});
    }
    displayPagePhoto(post) {
        const photo = post.page.photoUrl;
        if (!photo) {
            return photo;
        }
        return this.defaultPhoto;
    }
    get displayRecipientPhoto() {
        const photo = this.selectedRecipient?.photo?.blob?.originalUrl;
        if (!photo) {
            return photo;
        }
        return this.defaultPhoto;
    }
    postClicked(post, event) {
        this.shouldScrollToBottom = false;
        if ([
            '.fbpost-content',
            '.post-content',
            '.post-time',
            '.fbpost-name-and-badge',
        ].some((className) => event.target.matches(className))) {
            this.$store.commit('setSelectedFbpost', {});
            // Check if the clicked post is already expanded
            if (this.expandedPosts[post.baseGlobalId]) {
                // Close the clicked post if it is already expanded
                this.$set(this.expandedPosts, post.baseGlobalId, !this.expandedPosts[post.baseGlobalId]);
            }
            else {
                this.expandedPosts = Object.keys(this.expandedPosts).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {});
                // Toggle the expanded state of the clicked post if it is not expanded
                this.$set(this.expandedPosts, post.baseGlobalId, !this.expandedPosts[post.baseGlobalId]);
            }
        }
    }
    displayMessageImage(post) {
        if (!post || !post.photo) {
            return this.defaultPhoto;
        }
        const { originalUrl } = post.photo.blob;
        if (originalUrl) {
            return originalUrl;
        }
        return this.defaultPhoto;
    }
    displayMessengerMessageImage(message) {
        if (message.galleryPhotos.edges.length > 0) {
            return message.galleryPhotos.edges.node.photoUrl;
        }
        return '';
    }
    formatTime(date) {
        return moment(date).format('MM/DD/YYYY, h:mm A');
    }
    // private FetchFacebookPosts() {
    //   this.shouldScrollToBottom = false;
    //   if (this.isFetchMore) {
    //     return; // Do not fetch more if already in progress
    //   }
    //   const { endCursor, hasNextPage } = this.pageInfo;
    //   console.log(hasNextPage);
    //   if (hasNextPage) {
    //     this.isFetchMore = true; // Set flag to indicate fetch in progress
    //     this.$apollo
    //       .query({
    //         query: FetchFacebookPosts,
    //         variables: {
    //           pageRecipientUuid: this.selectedRecipient.uuid,
    //           prGlobalId: this.selectedRecipient.baseUuid,
    //           first: 5,
    //           after: endCursor,
    //         },
    //       })
    //       .then(({ data }) => {
    //         console.log(data);
    //         this.pageInfo = data.fetchFacebookPosts.pageInfo;
    //         const moreNodes = data.fetchFacebookPosts.edges.map((edge) => edge.node);
    //         const sortNodes = moreNodes.slice().reverse();
    //         this.fbPosts = [...sortNodes, ...this.fbPosts];
    //         const container = this.$refs.messageContent as HTMLElement;
    //         const originalScrollTop = container.scrollTop;
    //         (this.$refs.messageContent as InstanceType<typeof HTMLElement>).scrollTop =
    //           originalScrollTop + sortNodes.length * this.getItemHeight();
    //         this.isFetchMore = false;
    //       })
    //       .catch((err: any) => {
    //         console.log(err);
    //         this.isFetchMore = false;
    //       });
    //   } else {
    //     this.isFetchMore = false;
    //   }
    // }
    getItemHeight() {
        return 80;
    }
    handleScroll(event) {
        const list = event.target;
        const { scrollTop } = list;
        if (scrollTop <= 0) {
            // loadmore
            // this.fetchMessengerMessages();
        }
    }
    scrollToBottom() {
        if (!this.shouldScrollToBottom) {
            return;
        }
        this.$nextTick(() => {
            const container = this.$refs.messageContent;
            container.scrollTop = container.scrollHeight;
        });
    }
    mounted() {
        this.scrollToBottom();
    }
    updated() {
        this.scrollToBottom();
    }
};
__decorate([
    Getter('selectedRecipient')
], FacebookComments.prototype, "selectedRecipient", void 0);
__decorate([
    Getter('selectedFbpost')
], FacebookComments.prototype, "selectedFbpost", void 0);
__decorate([
    Watch('selectedRecipient')
], FacebookComments.prototype, "onSelectedRecipient", null);
FacebookComments = __decorate([
    Component({
        components: {
            InboxConversation,
        },
        apollo: {
            fbPostsAndMessages: {
                query: CopilotAllMessages,
                variables() {
                    return {
                        pageRecipientUuid: this.$store.state.selectedRecipient.uuid,
                        first: 100,
                        after: this.startCursor,
                        prGlobalId: this.$store.state.selectedRecipient.baseUuid,
                    };
                },
                skip() {
                    return !this.$store.state.selectedRecipient.uuid;
                },
                update({ fetchPostAndMessengerMessages }) {
                    if (fetchPostAndMessengerMessages) {
                        const fbPostsAndMessages = fetchPostAndMessengerMessages.edges.map((edge) => edge.node);
                        this.nodes = [...fbPostsAndMessages];
                        this.pageInfo = fetchPostAndMessengerMessages.pageInfo;
                        this.shouldScrollToBottom = true;
                        return this.nodes;
                    }
                },
            },
        },
    })
], FacebookComments);
export default FacebookComments;
